module.exports = __webpack_public_path__ + "static/media/4.773f6c59.jpg";